var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"log-list"},[_c('list',{attrs:{"fs":_vm.logFields,"api":"logs","showAction":false,"showSearch":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }